import React from 'react';
import PropTypes from 'prop-types';
import { EMPTINESS_SIGN } from 'rp-react-table';
import formatWeight from '../../../utils/formatWeight';
import ResultLink from '../../../shared/links/ResultLink';

function getDistance(outcomeCode, winDist, distToWin) {
    if (!winDist && !distToWin) { return null; }
    if (+outcomeCode === 1) { return <span>by {winDist}&nbsp;</span>; }
    return <span>btn {distToWin}&nbsp;</span>;
}

const FinishingCell = ({
    raceOutcomeCode,
    rpCloseUpComment,
    rpBettingMovements,
    noOfRunners,
    otherHorse = {},
    winningDistance,
    distanceToWinner,
    courseName,
    courseUid,
    raceDatetime,
    raceInstanceUid,
}) => (
    <span>
        <span
            className={(raceOutcomeCode === 'NR')
            && 'nonRunnerSliderSwitcherHideData'}
        >
            <strong>{raceOutcomeCode}</strong>/{noOfRunners}&nbsp;
            <ResultLink
                courseName={courseName}
                courseUid={courseUid}
                raceDatetime={raceDatetime}
                raceInstanceUid={raceInstanceUid}
                raceInstanceTitle={
                    `${rpCloseUpComment}${rpBettingMovements ? ` (${rpBettingMovements})` : ''}`
                }
                className="hidden-sm-down"
            >
                {getDistance(raceOutcomeCode, winningDistance, distanceToWinner)}
                { otherHorse && (
                    <span>
                        {otherHorse.styleName}&nbsp;
                        {formatWeight(otherHorse.weightCarriedLbs)}
                    </span>
                )}
            </ResultLink>
        </span>
        {(raceOutcomeCode === 'NR') &&
            <span>
                <strong
                    className="nonRunnerSliderSwitcherData"
                >
                    Non Runner{!!rpCloseUpComment && ` (${rpCloseUpComment})`}
                </strong>
                <span className="nonRunnerSliderSwitcherData__exNarrow">
                    {EMPTINESS_SIGN}
                </span>
            </span>}
    </span>
);

FinishingCell.propTypes = {
    raceOutcomeCode: PropTypes.string,
    rpCloseUpComment: PropTypes.string,
    rpBettingMovements: PropTypes.string,
    noOfRunners: PropTypes.number,
    otherHorse: PropTypes.shape({
        styleName: PropTypes.string,
        weightCarriedLbs: PropTypes.number,
    }),
    winningDistance: PropTypes.number,
    distanceToWinner: PropTypes.string,
    courseName: PropTypes.string,
    courseUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceUid: PropTypes.number,
};

export default FinishingCell;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/FinishingCell.jsx